import React from 'react';
import { Grid } from "@mui/material";
import TextField from "../../../../../controls/TextField";
import Checkbox from "../../../../../controls/Checkbox";
import { useFormContext } from "react-hook-form";
import { DataRobot } from '../../../api/api-types';

export type CredentialsInput = Props;

type Props = NonNullable<DataRobot>

const CredentialsForm: React.FC<Partial<Props>> = (defaultValues) => {
    const { register, errors,  setValue, watch } = useFormContext<Props>();
    const isLegacy = watch('isLegacy')

    return (
        <Grid container alignContent={'flex-start'} justifyContent={'center'} direction={'row'} spacing={2}>
            <Grid item xs={12} sm={10}>
                <Checkbox defaultChecked={defaultValues.isLegacy}
                    name={'isLegacy'} label={'I want to use the old data robot route'}
                    inputRef={register}
                    onChange={e => {
                        if (e.target.checked) {
                            setValue('isLegacy', true);
                        }
                        else {
                            setValue('isLegacy', false);
                        }
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={10}>
                <TextField name={'deployment'} fullWidth
                    defaultValue={defaultValues.deployment}
                    label={'Deployment ID'}
                    disabled={isLegacy}
                    inputRef={register({
                        validate: {
                            length: (v: string) => isLegacy || v.trim().length === 24
                        }}
                    )}
                    error={Boolean(errors.deployment)}
                    helperText={errors.deployment?.message || (errors.deployment?.type === 'required' && 'Required')
                        || (errors.deployment?.type === 'length' && 'Must be 24 characters') || ' '} />
            </Grid>
            <Grid item xs={12} sm={10}>
                <TextField name={'project'} fullWidth
                    defaultValue={defaultValues.project}
                    label={'Project ID'}
                    disabled={!isLegacy}
                    inputRef={register({
                        validate: {
                            length: (v: string) => !isLegacy || v.trim().length === 24
                        }}
                    )}
                    error={Boolean(errors.project)}
                    helperText={errors.project?.message || (errors.project?.type === 'required' && 'Required')
                        || (errors.project?.type === 'length' && 'Must be 24 characters') || ' '} />
            </Grid>
            <Grid item xs={12} sm={10}>
                <TextField name={'model'} fullWidth
                     defaultValue={defaultValues.model}
                    label={'Model ID'}
                    disabled={!isLegacy}
                    inputRef={register({
                        validate: {
                            length: (v: string) => !isLegacy || v.trim().length === 24
                        }}
                    )}
                    error={Boolean(errors.model)}
                    helperText={errors.model?.message || (errors.model?.type === 'required' && 'Required')
                        || (errors.model?.type === 'length' && 'Must be 24 characters') || ' '} />
            </Grid>

        </Grid>
    );
}

export default CredentialsForm;